<template>
  <div class="modal-tutorial">
    <button @click="closeModal" class="modal-tutorial__close">
      <BaseIcon name="cross"/>
    </button>

    <transition name="modal-tutorial-fade">
      <iframe
        v-visible="!loading"
        @load="loading = false"
        :src="modalData.src"
        width="100%" height="100%" frameborder="0"
        ></iframe>
    </transition>

    <BaseSpinnerBig class="modal-tutorial__spinner" v-if="loading"/>
  </div>
</template>

<script>
  import { MDSModalIframeModel } from '@/models/modal-datasets.model'

  export default {
    props: {
      modalData: MDSModalIframeModel
    },
    data () {
      return {
        loading: true
      }
    },
    methods: {
      closeModal () {
        this.$store.commit('modals/CLOSE_LAST_MODAL')
      }
    }
  }
</script>

<style lang="scss">
  @import './src/assets/styles/breakpoints.scss';
  @import './src/assets/styles/grid.scss';
  @import './src/assets/styles/colors.scss';

  .modal-tutorial {
    position: relative;
    width: calc(100% - 100px);
    height: calc(100% - 85px);
    margin-top: -20px;
    overflow: hidden;

    @include media(ltTablet) {
      width: calc(100% - #{$container-gutter} * 2);
      height: calc(100% - #{$container-gutter} * 2);
    }

    @include media(ltTablet) {
      width: calc(100% - #{$container-gutter-mobile} * 2);
      height: calc(100% - #{$container-gutter-mobile} * 2);
    }

    &__close {
      position: absolute;
      top: 4px;
      right: 4px;
      padding: 20px;
      cursor: pointer;
      z-index: 9;

      &:focus {
        outline: 2px solid $color-purple;
      }

      svg {
        width: 12px;
        height: 12px;
      }
    }

    &__spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &-fade-enter-active, &-fade-leave-active {
      transition: opacity .5s;
    }

    &-fade-enter, &-fade-leave-to {
      opacity: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/modals/modals-content/ModalIframe.vue